/*
 * Filename: c:\Users\aasan_95ppk60\OneDrive\Documents\College\git\usocial-r\USocial-R\usocial-app\src\about.jsx
 * Path: c:\Users\aasan_95ppk60\OneDrive\Documents\College\git\usocial-r\USocial-R\usocial-app
 * Created Date: Saturday, December 9th 2023, 4:38:59 pm
 * Author: Alejandro Santiago, Hunter Oxley
 * 
 * 
 * Title: about.jsx
 * Description: About page for authors of website
 * Copyright (c) 2023  
 */

import React from 'react'
import { Card } from 'react-bootstrap'
import {Link} from 'react-router-dom'

const About = () => {
  
  return (
    <div className='about'>
      <div className='container'>
        <div className='cards'>
          <Card>
            <Card.Body>
              <Card.Title>What is USocial?</Card.Title>
              <Card.Text>
                Usocial is designed to make managing your schedule and staying productive at West Virginia University simple by having everything you would need in one place.
                We offer a calendar for you to input assignments or events, assign a time to each item and save it.
                We also allow users to message fellow WVU students for homework help or scheduling. USocial was created by a team of students at West Virginia University as a group project for CS 230. 
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>

      <Link to = "/profile/:userId">
      <button id = "cancel">Back</button>
    </Link>
      
    </div>
    
  );
};
  


export default About
